import React from "react";
import { Pagination } from "react-bootstrap";

interface PaginationProps {
    total: number;
    limit: number;
    offset: number;
    onPageChange: (newOffset: number) => void;
}

const PaginationComponent: React.FC<PaginationProps> = ({
    total,
    limit,
    offset,
    onPageChange,
}) => {
    const totalPages = Math.ceil(total / limit);
    const currentPage = Math.floor(offset / limit) + 1;

    const handlePageChange = (newPage: number) => {
        const newOffset = (newPage - 1) * limit;
        onPageChange(newOffset);
    };

    return (
        <Pagination className="justify-content-center mt-4">
            <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
            />
            {[...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                    key={index}
                    active={index + 1 === currentPage}
                    onClick={() => handlePageChange(index + 1)}
                >
                    {index + 1}
                </Pagination.Item>
            ))}
            <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            />
        </Pagination>
    );
};

export default PaginationComponent;